export function PoweredBy() {
	return (
		<div className="bg-white px-4 border-t border-slate-100">
			<div className="max-w-xl mx-auto text-center flex justify-center items-center gap-x-1 py-8 ">
				<p className="font-medium mt-1 text-[#424658] text-sm">Powered by</p>
				<div role="img" aria-label="Jobilla">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlSpace="preserve"
						x={0}
						y={0}
						height="30px"
						width="100px"
						viewBox="0 0 1891.6 527"
					>
						<style>
							{'.st0{fill:#fff}.st23{fill:#07c4fc}.st25{fill:#39d0fd}.st26{fill:#6adcfd}'}
						</style>
						<path
							d="M480.5 179.8c-.1-10.4-3.5-19.5-9-26.7-7.6-10.3-19.6-17.6-34.9-17.9H109.3c-24.8 0-45 20.2-45 45.1v235.4c.1 10.3 3.5 19.4 9 26.7 7.6 10.3 19.6 17.6 34.9 17.9h327.3c24.8 0 45-20.2 45-45.1V179.8z"
							className="st0"
						/>
						<path fill="#304ffb" d="M256.1 30.5h32.6v75.2h-32.6z" />
						<linearGradient
							id="SVGID_1_"
							x1={159.89}
							x2={384.852}
							y1={135.605}
							y2={135.605}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#304ffb" />
							<stop offset={1} stopColor="#39d0fd" />
						</linearGradient>
						<path
							fill="url(#SVGID_1_)"
							d="M355 105.8H189.7c-16.5 0-29.9 13.4-29.9 29.9s13.4 29.9 29.9 29.9H355c16.5 0 29.9-13.4 29.9-29.9 0-16.6-13.4-29.9-29.9-29.9z"
						/>
						<linearGradient
							id="SVGID_00000148636957559625441360000004382704108576524723_"
							x1={63.99}
							x2={480.816}
							y1={298.012}
							y2={298.012}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000148636957559625441360000004382704108576524723_)"
							d="M64 415.6V180.4c0-24.9 20.2-45.2 45.1-45.2h326.6c43.8 0 61.8 56.2 26.3 81.8L135.3 452.3c-29.8 21.4-71.3.1-71.3-36.7z"
						/>
						<linearGradient
							id="SVGID_00000010303671272114126610000005536678217312256951_"
							x1={63.99}
							x2={480.816}
							y1={298.012}
							y2={298.012}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000010303671272114126610000005536678217312256951_)"
							d="M480.8 180.4v235.2c0 24.9-20.2 45.2-45.1 45.2H109.1c-43.8 0-61.8-56.2-26.3-81.8l326.6-235.2c29.9-21.5 71.4-.2 71.4 36.6z"
							opacity={0.82}
						/>
						<linearGradient
							id="SVGID_00000050621340049594110370000009722419058842183048_"
							x1={7408.398}
							x2={7356.921}
							y1={9217.41}
							y2={9306.572}
							gradientTransform="rotate(180 3864.418 4872.893)"
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000050621340049594110370000009722419058842183048_)"
							d="M409.4 460.8h-99.9v55.8c0 7.6 8.4 12 14.5 7.6l85.4-63.4z"
						/>
						<linearGradient
							id="SVGID_00000046301095215063906090000013848937429855924132_"
							x1={243.588}
							x2={301.155}
							y1={70.572}
							y2={13.005}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<circle
							cx={272.4}
							cy={41.8}
							r={40.7}
							fill="url(#SVGID_00000046301095215063906090000013848937429855924132_)"
						/>
						<circle cx={358.1} cy={297.8} r={102} className="st23" />
						<ellipse cx={358.1} cy={298.8} className="st0" rx={69.4} ry={69.6} />
						<linearGradient
							id="SVGID_00000170239731014499731020000013217986748166900627_"
							x1={320.043}
							x2={396.154}
							y1={298.838}
							y2={298.838}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#304ffb" />
							<stop offset={1} stopColor="#1028ae" />
						</linearGradient>
						<circle
							cx={358.1}
							cy={298.8}
							r={38.1}
							fill="url(#SVGID_00000170239731014499731020000013217986748166900627_)"
						/>
						<path
							d="M493.1 252.2h-44.2c7.3 14 11.4 29.8 11.4 46.7s-4.1 32.7-11.4 46.7h44.2c25.7 0 46.7-21 46.7-46.7-.1-25.7-21.1-46.7-46.7-46.7z"
							className="st23"
						/>
						<path
							d="M492.8 345.5c25.7 0 46.8-21 46.8-46.7 0-25.7-21.1-46.7-46.8-46.7h-12.1v93.4h12.1z"
							className="st25"
						/>
						<path
							d="M460.3 298.8c0-16.8-4.1-32.7-11.4-46.7h-39.3c11.1 12.3 17.9 28.7 17.9 46.7 0 18-6.8 34.3-17.9 46.7h39.3c7.2-14 11.4-29.8 11.4-46.7z"
							className="st26"
						/>
						<circle cx={186.6} cy={298} r={102} className="st23" />
						<ellipse cx={186.6} cy={298} className="st0" rx={69.4} ry={69.6} />
						<linearGradient
							id="SVGID_00000148652787675914242140000012855567057341698944_"
							x1={13466.839}
							x2={13542.95}
							y1={298.012}
							y2={298.012}
							gradientTransform="matrix(-1 0 0 1 13691.54 0)"
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#304ffb" />
							<stop offset={1} stopColor="#1028ae" />
						</linearGradient>
						<circle
							cx={186.6}
							cy={298}
							r={38.1}
							fill="url(#SVGID_00000148652787675914242140000012855567057341698944_)"
						/>
						<path
							d="M51.7 251.3h44.2c-7.3 14-11.4 29.8-11.4 46.7s4.1 32.7 11.4 46.7H51.7C26 344.7 5 323.7 5 298c0-25.7 21-46.7 46.7-46.7z"
							className="st23"
						/>
						<path
							d="M51.9 344.7c-25.7 0-46.8-21-46.8-46.7 0-25.7 21.1-46.7 46.8-46.7H64v93.4H51.9z"
							className="st25"
						/>
						<path
							d="M84.5 298c0-16.8 4.1-32.7 11.4-46.7h39.3c-11.2 12.4-18 28.7-18 46.7 0 18 6.8 34.3 17.9 46.7H95.9c-7.3-14-11.4-29.9-11.4-46.7z"
							className="st26"
						/>
						<linearGradient
							id="SVGID_00000022526291870444736930000017879264505144410011_"
							x1={703.988}
							x2={703.988}
							y1={460.794}
							y2={104.144}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000022526291870444736930000017879264505144410011_)"
							d="M782.2 104.1c-13 0-23.5 10.5-23.5 23.5V356c0 .5 0 1 .1 1.6 0 .5-.1 1-.1 1.6 0 30.2-24.5 54.7-54.7 54.7-30.2 0-54.7-24.5-54.7-54.7 0-13-10.5-23.5-23.5-23.5s-23.5 10.5-23.5 23.5c0 56.2 45.5 101.7 101.7 101.7s101.7-45.5 101.7-101.7c0-.5 0-1-.1-1.6 0-.5.1-1 .1-1.6V127.6c0-13-10.5-23.5-23.5-23.5z"
						/>
						<linearGradient
							id="SVGID_00000122714474760694108770000009915619912958353302_"
							x1={1493.937}
							x2={1493.937}
							y1={460.794}
							y2={104.144}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000122714474760694108770000009915619912958353302_)"
							d="M1493.9 104.1c-13 0-23.5 10.5-23.5 23.5v309.7c0 13 10.5 23.5 23.5 23.5s23.5-10.5 23.5-23.5V127.6c0-13-10.5-23.5-23.5-23.5z"
						/>
						<linearGradient
							id="SVGID_00000126303851734396443190000000522610709787309710_"
							x1={1400.082}
							x2={1400.082}
							y1={460.794}
							y2={226.156}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000126303851734396443190000000522610709787309710_)"
							d="M1400.1 226.2c-13 0-23.5 10.5-23.5 23.5v187.7c0 13 10.5 23.5 23.5 23.5s23.5-10.5 23.5-23.5V249.6c-.1-12.9-10.6-23.4-23.5-23.4z"
						/>
						<linearGradient
							id="SVGID_00000030483974359828807100000002235553054163657393_"
							x1={954.269}
							x2={954.269}
							y1={460.794}
							y2={226.156}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000030483974359828807100000002235553054163657393_)"
							d="M954.3 226.2c-64.8 0-117.3 52.5-117.3 117.3s52.5 117.3 117.3 117.3 117.3-52.5 117.3-117.3-52.5-117.3-117.3-117.3zm0 187.7c-38.9 0-70.4-31.5-70.4-70.4 0-38.9 31.5-70.4 70.4-70.4 38.9 0 70.4 31.5 70.4 70.4 0 38.9-31.6 70.4-70.4 70.4z"
						/>
						<linearGradient
							id="SVGID_00000038378936142605135900000011452144745168744633_"
							x1={1400.082}
							x2={1400.082}
							y1={151.072}
							y2={104.144}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<circle
							cx={1400.1}
							cy={127.6}
							r={23.5}
							fill="url(#SVGID_00000038378936142605135900000011452144745168744633_)"
						/>
						<linearGradient
							id="SVGID_00000133530536352648336630000006013608596859262647_"
							x1={1587.792}
							x2={1587.792}
							y1={460.795}
							y2={104.144}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000133530536352648336630000006013608596859262647_)"
							d="M1587.8 104.1c-13 0-23.5 10.5-23.5 23.5v309.7c0 13 10.5 23.5 23.5 23.5s23.5-10.5 23.5-23.5V127.6c0-13-10.5-23.5-23.5-23.5z"
						/>
						<linearGradient
							id="SVGID_00000006693881693939672450000002618816193956905660_"
							x1={1767.682}
							x2={1767.682}
							y1={460.794}
							y2={226.156}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000006693881693939672450000002618816193956905660_)"
							d="M1882.9 321.6c-10.3-54.3-57.9-95.4-115.2-95.4-64.8 0-117.3 52.5-117.3 117.3s52.5 117.3 117.3 117.3h23.4c13 0 23.5-10.5 23.5-23.5s-10.5-23.5-23.5-23.5h-23.4c-38.9 0-70.4-31.5-70.4-70.4 0-38.9 31.5-70.4 70.4-70.4 31.2 0 57.7 20.3 66.9 48.5 2.3 6.9 3.5 14.3 3.5 21.9v92.8h.1c0 .4-.1.7-.1 1.1 0 12.2 9.3 22.2 21.1 23.3.8.1 1.6.1 2.3.1 13 0 23.5-10.5 23.5-23.5v-93.9c0-7.3-.7-14.6-2.1-21.7z"
						/>
						<linearGradient
							id="SVGID_00000158715802213110970110000015531800888106770560_"
							x1={1220.192}
							x2={1220.192}
							y1={460.706}
							y2={104.056}
							gradientUnits="userSpaceOnUse"
						>
							<stop offset={0} stopColor="#710de0" />
							<stop offset={1} stopColor="#304ffb" />
						</linearGradient>
						<path
							fill="url(#SVGID_00000158715802213110970110000015531800888106770560_)"
							d="M1220.2 226.1h-23.4c-13 0-23.5 10.5-23.5 23.5s10.5 23.5 23.5 23.5h23.4c38.9 0 70.4 31.5 70.4 70.4s-31.5 70.4-70.4 70.4c-34.1 0-62.5-24.2-69-56.3-.9-4.5-1.4-9.3-1.4-14.1V127.6c0-.5 0-1-.1-1.6-.8-12.2-11-21.9-23.4-21.9-13 0-23.5 10.5-23.5 23.5v215.8c0 64.8 52.5 117.3 117.3 117.3s117.3-52.5 117.3-117.3-52.4-117.3-117.2-117.3z"
						/>
					</svg>
				</div>
			</div>
		</div>
	)
}
